import { NoticeBannerList } from 'noddi-web';
import { getNoticeBannerTranslations } from '../../utils/commonTranslations';
import { useCustomerNotices } from './useCustomerNotices';

const bannerClassName = 'mx-auto flex w-full max-w-5xl flex-col gap-2 px-4 pt-2';

// Content cards for this brand. Hidden when the fetch fails.
export const NoticeBanner = () => {
  const { isBrandPending, error, content } = useCustomerNotices();

  if (isBrandPending || error) {
    return null;
  }

  return (
    <NoticeBannerList notices={content} className={bannerClassName} translations={getNoticeBannerTranslations()} />
  );
};
